import React from 'react';
import { NotFound } from '../components/notFound/NotFound';
import { useLoadingContext } from '../components/contexts/LoadingContext';
import { LoadingSkeleton } from '../components/LoadingSkeleton';

function NotFoundRoute() {
    const { loading } = useLoadingContext();

    return loading ? <LoadingSkeleton /> : <NotFound />;
}

export default React.memo(NotFoundRoute);
